/* eslint-disable camelcase */
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import queryString from 'query-string';
import NotificationService, { AlertTypes } from 'Services/notification';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import {
  signInSocialAction,
  setUserCouponAction,
  setUserCodeAction,
} from 'Store/modules/auth/actions';
import { searchSelector } from 'Store/modules/router/selectors';
import { useTranslation } from 'Hooks/useTranslation';
import { routes } from 'Constants/routes';
import View from './view';

const SignIn = (): JSX.Element => {
  const dispatch = useDispatch();
  const [socialLoginError, setSocialLoginError] = useState(false);
  const { t } = useTranslation(locizeNS.AUTH);
  const search = useSelector(searchSelector);
  const params = queryString.parse(search);

  const onSignInSocial = (provider): void => {
    dispatch(signInSocialAction(provider));
  };

  useEffect(() => {
    const { social_provider, coupon, error, code, s: source } = params;
    if (error) {
      NotificationService.sendNotification(t('Login.socialLoginError'), AlertTypes.error);
      setSocialLoginError(true);
      history.replace(routes.SIGNIN);
    }
    if (coupon) {
      dispatch(setUserCouponAction(coupon));
    }
    if (code && source) {
      dispatch(setUserCodeAction(code, source));
    }
    if (social_provider) {
      onSignInSocial(params?.social_provider);
    }
  }, []);

  return <View onSignInSocial={onSignInSocial} errorSocialLogin={socialLoginError} />;
};

export default SignIn;
